(function ($) {
  $('.map').each(function () {
    const $thisMap = $(this);
    const $mapPins = $('.paragraph--map-pin', $thisMap);
    const $mapDirectionsLinks = $(
      '.map-pin__direction-container > a',
      $thisMap,
    );

    // Setup initial map image / active state
    let firstImage = $thisMap
      .find(
        '.field--name-field-map-pin .field__item:first-child .map-pin__preview',
      )
      .attr('data-image');

    $thisMap
      .find(
        '.field--name-field-map-pin .field__item:first-child .map-pin__preview',
      )
      .addClass('active');

    $thisMap
      .find('.map-image')
      .css('background-image', 'url(' + firstImage + ')');

    // Bind event listener(s)
    // ---

    $mapPins.on('click mouseenter', function (e) {
      e.preventDefault();
      const $thisPin = $(this);

      let getImage = $thisPin.find('.map-pin__preview').attr('data-image');

      $thisPin.closest('.map').find('.map-pin__preview').removeClass('active');

      $thisPin.find('.map-pin__preview').addClass('active');

      $thisPin
        .closest('.map')
        .find('.map-image')
        .css('background-image', 'url(' + getImage + ')');
    });

    $mapDirectionsLinks.click(function (e) {
      e.stopPropagation();
    });
  });
})(jQuery);
